export default __webpack_public_path__ + "static/media/oscer-pres-dysphagia.d78d719e.svg";